import API from "../API";

export const CreateOrderRazApi = async (payload) => {
  try {
    const response = await API.post(`/addon/products`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const PlaceOrderApi = async (payload) => {
  try {
    const response = await API.post(`/orders`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrdersApi = async (payload) => {
  try {
    const response = await API.get(`/orders`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSingleOrdersApi = async (payload) => {
  try {
    const response = await API.get(`/orders/${payload?.orderId || null}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelOrdersApi = async (payload) => {
  try {
    const response = await API.put(`/request/${payload?.actionId || ''}/cancel`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const returnOrdersApi = async (payload) => {
  try {
    const response = await API.put(`/request/${payload?.orderItemId || ''}/return`);
    return response;
  } catch (error) {
    throw error;
  }
};